import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-footer" }


export default /*@__PURE__*/_defineComponent({
  __name: 'AppFooter',
  setup(__props) {

// Keine Logik erforderlich

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "container" }, [
      _createElementVNode("p", { class: "footer-text" }, [
        _createTextVNode(" Powered by "),
        _createElementVNode("a", {
          href: "https://www.spotify.com",
          target: "_blank",
          rel: "noopener noreferrer",
          class: "spotify-link"
        }, " Spotify ")
      ])
    ], -1)
  ]))]))
}
}

})